export const finedTestDrive = "/product/find-test-drives";
export const locationFindAll = "/location/find-all";
export const orderBookTestDrive = "/requests";
export const userInfo = "/requests/book-test-drive";
